module.exports = __webpack_public_path__ + "static/media/ZhiBo2.a34e3971.png";